import { useState } from 'react';
import { X, FileUp, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const CadAssistantFloat = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="fixed bottom-20 right-6 z-40 hidden sm:block">
      {/* Popover */}
      {isOpen && (
        <div className="absolute bottom-16 right-0 w-72 bg-white dark:bg-gray-800 rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 p-4 animate-fade-in">
          <button
            onClick={() => setIsOpen(false)}
            className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
          >
            <X className="w-4 h-4" />
          </button>
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 bg-blue-100 dark:bg-blue-900/40 rounded-lg flex items-center justify-center">
              <FileUp className="w-5 h-5 text-blue-600 dark:text-blue-400" />
            </div>
            <p className="text-sm font-semibold text-gray-900 dark:text-white">
              Conversión CAD a GeoJSON
            </p>
          </div>
          <p className="text-xs text-gray-600 dark:text-gray-400 mb-3">
            ¿Tus lotes están en formato CAD o GIS? Para usarlos en el sistema necesitas un GeoJSON. Conoce empresas con experiencia que pueden hacer la conversión por ti.
          </p>
          <button
            onClick={() => {
              setIsOpen(false);
              navigate('/servicios-conversion');
            }}
            className="w-full py-2 px-3 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold rounded-lg transition-colors flex items-center justify-center gap-1.5"
          >
            Ver empresas disponibles
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      )}

      {/* Botón flotante tipo pill: se explica solo y llama la atención */}
      <div className="relative">
        {/* Anillo pulsante (solo cuando está cerrado, para no distraer con el popover abierto) */}
        {!isOpen && (
          <span
            aria-hidden="true"
            className="absolute inset-0 rounded-full bg-blue-500 opacity-40 animate-ping"
          />
        )}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="relative flex items-center gap-2 pl-4 pr-5 py-3 rounded-full bg-gradient-to-br from-blue-600 to-indigo-600 text-white shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-200"
          title="Convierte tus archivos CAD a GeoJSON"
        >
          <FileUp className="w-5 h-5 flex-shrink-0" />
          <span className="text-sm font-bold whitespace-nowrap">CAD → GeoJSON</span>
        </button>
      </div>
    </div>
  );
};

export default CadAssistantFloat;
